export default __webpack_public_path__ + "static/indoor24-b98a56da6372c727a7228f3d0128fd30.webp";